export default __webpack_public_path__ + "static/media/pte_3.86eb145f.png";